import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetTapToBorrowTypeMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  tap_to_borrow_type: Types.TapToBorrowType;
}>;


export type SetTapToBorrowTypeMutation = { __typename?: 'Mutation', adminUpdateUser?: { __typename?: 'User', id: string, tap_to_borrow_type: Types.TapToBorrowType } | null };


export const SetTapToBorrowTypeDocument = gql`
    mutation setTapToBorrowType($id: ID!, $tap_to_borrow_type: TapToBorrowType!) {
  adminUpdateUser(id: $id, item: {tap_to_borrow_type: $tap_to_borrow_type}) {
    id
    tap_to_borrow_type
  }
}
    `;
export type SetTapToBorrowTypeMutationFn = Apollo.MutationFunction<SetTapToBorrowTypeMutation, SetTapToBorrowTypeMutationVariables>;

/**
 * __useSetTapToBorrowTypeMutation__
 *
 * To run a mutation, you first call `useSetTapToBorrowTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTapToBorrowTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTapToBorrowTypeMutation, { data, loading, error }] = useSetTapToBorrowTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tap_to_borrow_type: // value for 'tap_to_borrow_type'
 *   },
 * });
 */
export function useSetTapToBorrowTypeMutation(baseOptions?: Apollo.MutationHookOptions<SetTapToBorrowTypeMutation, SetTapToBorrowTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTapToBorrowTypeMutation, SetTapToBorrowTypeMutationVariables>(SetTapToBorrowTypeDocument, options);
      }
export type SetTapToBorrowTypeMutationHookResult = ReturnType<typeof useSetTapToBorrowTypeMutation>;
export type SetTapToBorrowTypeMutationResult = Apollo.MutationResult<SetTapToBorrowTypeMutation>;
export type SetTapToBorrowTypeMutationOptions = Apollo.BaseMutationOptions<SetTapToBorrowTypeMutation, SetTapToBorrowTypeMutationVariables>;